/* eslint-disable no-new */

import { getVariantFromOptionArray } from '@shopify/theme-product'
import formatMoney from '../utilities/shopify-format-money.js'
import { swiperDefaults } from '../globals.js'
import Swiper, { A11y, Navigation, Pagination } from 'swiper'

/**
 * Product Variant Switching
 */
const optionSelectors = document.querySelectorAll('[data-product-option]')
let lastClick = 0
/**
 *
 */
const handleProductOptionChange = (event) => {
    const masterSelect = document.querySelector('#product-select')
    const options = masterSelect.querySelectorAll('option')
    const specsSection = document.querySelectorAll('.productSpecifications__variantWrapper .productPill input')
    const optionsArray = [...optionSelectors].map((option) => option.querySelector(':checked').value)
    const selectedVariant = getVariantFromOptionArray(window.product.data, optionsArray)
    const priceElement = document.querySelector('[data-price]')
    const proPrice = parseInt(window.variantsMeta.metafields[`${selectedVariant.id}`].proPrice)

    if (!selectedVariant) {
        const addToCartButton = document.querySelector('.addToCart')
        priceElement.innerHTML = '<br>'
        addToCartButton.innerHTML = 'Unavailable'
        addToCartButton.setAttribute('disabled', 'disabled')
        return
    }

    let format
    if (priceElement.getAttribute('name') === 'CA') {
        format = '${{amount}} CAD'
    } else {
        format = '${{amount}}'
    }

    const selectedVariantQuantity = window.product.inventory[selectedVariant.id]
    const { target } = event
    let { internalId } = target.dataset

    priceElement.innerHTML = formatMoney(selectedVariant.price, format)

    if (selectedVariant.compare_at_price) {
        priceElement.innerHTML = `<del>${formatMoney(selectedVariant.compare_at_price, format)}</del> ${formatMoney(selectedVariant.price, format)}`
    } else if (proPrice) {
        priceElement.innerHTML = `<del>${formatMoney(selectedVariant.price, format)}</del> ${formatMoney(proPrice, format)}`
    } else {
        priceElement.innerHTML = formatMoney(selectedVariant.price, format)
    }

    if (!internalId) {
        options.forEach(item => {
            const attr = item.getAttribute('data-internal-id')
            if (item.getAttribute('value') === selectedVariant.id.toString()) {
                internalId = attr
            }
        })
    }

    if ('$BV' in window) {
        window.$BV.ui('rr', 'show_reviews', {
            productId: internalId
        })
    }

    masterSelect.value = selectedVariant.id
    masterSelect.dispatchEvent(new Event('change'))

    handleAddToCartButtonStateUpdate(selectedVariant)
    handleInventoryNoticeDisplay(selectedVariantQuantity)
    handleVariantUrlUpdate(selectedVariant.id)

    // trigger specs update
    specsSection.forEach(item => {
        const attr = item.getAttribute('data-internal-id')
        if (attr === selectedVariant.id.toString()) {
            item.click()
        }
    })

    // Locally method to reload product locator
    if ((lastClick + 1000) < Date.now()) {
        lcly_reload_0({ upc: selectedVariant.sku })
        lastClick = Date.now()
    }
}

/**
 *
 * @param variantId
 */
const handleVariantUrlUpdate = (variantId) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('variant', variantId)
    window.history.replaceState({}, '', `${location.pathname}?${searchParams}`)
}

if (optionSelectors) {
    optionSelectors.forEach((optionSelector) => {
        optionSelector.addEventListener('change', handleProductOptionChange)
    })
}

/**
 *
 * @param variantAvailableQuantity
 */
const handleInventoryNoticeDisplay = (variantAvailableQuantity) => {
    const inventoryNotice = document.querySelector('[data-inventory-notice]')

    if (variantAvailableQuantity <= 5 && variantAvailableQuantity > 0) {
        inventoryNotice.innerHTML = `Only ${variantAvailableQuantity} left in stock!`
        return
    }

    inventoryNotice.innerHTML = ''
}

/**
 *
 * @param variantAvailable
 */
const handleAddToCartButtonStateUpdate = (selectedVariant) => {
    const addToCartButton = document.querySelector('.addToCart')
    const outOfStock = window.variantsMeta.metafields[`${selectedVariant.id}`].outOfStock;

    if (!selectedVariant.available && selectedVariant?.featured_image?.product_id !== '7445240316077aq') {
        addToCartButton.innerHTML = outOfStock ? 'Out of Stock' : 'Sold Out | <span onclick="openBackInStockModal()" class="trellis-bis-trigger" style="text-decoration: underline; cursor: pointer;">Join the waitlist</span>'
        addToCartButton.setAttribute('disabled', 'disabled')
        return
    }

    addToCartButton.innerHTML = 'Add to Cart'
    addToCartButton.removeAttribute('disabled')
}

/**
 * Product Gallery Slider
 */
new Swiper('[data-product-gallery]', {
    ...swiperDefaults,
    centeredSlides: true,
    slidesPerView: 1.75,
    loop: true,
    modules: [Pagination, Navigation, A11y]
})

/**
 * Product Video Slider
 */
new Swiper('[data-video-gallery]', {
    ...swiperDefaults,
    slidesPerView: 1.05,
    spaceBetween: 30,
    modules: [Pagination, Navigation, A11y]
})

/**
 * Product Feature Slider
 */
new Swiper('[data-feature-slider]', {
    ...swiperDefaults,
    slidesPerView: 1.25,
    spaceBetween: 30,
    lazy: true,
    loop: true,
    centeredSlides: true,
    modules: [Navigation, A11y],
    breakpoints: {
        701: {
            slidesPerView: 1.5
        },
        951: {
            slidesPerView: 2.5
        },
        1280: {
            slidesPerView: 3.5
        }
    }
})

/**
 * Related Products Slider
 */
const mediaQuery = window.matchMedia('(max-width:59.375em)')
let swiperInstance = false

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-related-products-slider]')) {
            swiperInstance = new Swiper('[data-related-products-slider]', {
                ...swiperDefaults,
                slidesPerView: 1.5,
                spaceBetween: 30,
                modules: [Navigation, A11y],
                breakpoints: {
                    700: {
                        slidesPerView: 2.5
                    }
                }
            })
            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)
